export default function capitalizeWords(sentence) {
  if (!!sentence && !!sentence.length && 'string' === typeof sentence) {
    let words = sentence.toLocaleLowerCase().split(' ');
    return words.map(word => !!word.length ? `${word[0].toLocaleUpperCase()}${word.substr(1)}`: word).join(' ');
  }
  return sentence;
}
